<template>
    <Question
        :question="question"
        :answers="answers"
        @select="$emit('action', $event)"
    />
</template>

<script>
import Question from '../Question';

export default {
    name: 'RemoveQuestion',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        answers: [{
            key: 'remove',
            text: 'Выбрать обучение',
            redirect: { name: 'profession-list' },
        }],
    }),
    computed: {
        question() {
            if (this.item.educationType === 'rsv_webinar') {
                return 'Вебинар не пройден.\n' +
                    'Обучение будет удалено из трека.';
            }
            return 'Обучение не пройдено и будет удалено из трека.';
        },
    },
    components: {
        Question,
    },
};
</script>

<style scoped lang="scss">
</style>